<script>
  import { onMount } from "svelte";
  import { writable, get } from "svelte/store";
  import {
    submitted,
    canBuy,
    canAddToShoppingCart,
    useGiftCards,
    requiredQuestionsAnswered,
  } from "./store";

  export let form;
  export let allowShoppingCart = true;
  export let isMobile = true;
  export let strings = {};

  const CLASSES = {
    DESKTOP: {
      CONTAINER: "flex gap-4 justify-center",
      CELL: "flex",
      CART: "big-secondary-button",
      PAY: "big-primary-button ",
    },
    MOBILE: {
      CONTAINER: "tc-grid__plain shadow-lg",
      CELL: "tc-grid--cell __plain",
      CART: "tc-button __block __size-sticky bg-mainSecondaryBackground text-mainSecondaryForeground __flat flex gap-2 justify-center items-center",
      PAY: "tc-button __block __size-sticky bg-mainPrimaryBackground text-mainPrimaryForeground __flat flex gap-2 justify-center items-center",
    },
  };

  $: classes = isMobile ? CLASSES.MOBILE : CLASSES.DESKTOP;

  $: containerClass = classes.CONTAINER;
  $: cellClass = classes.CELL;
  $: cartClass = classes.CART;
  $: payClass = classes.PAY;

  $: shoppingCartDisabled = !$canAddToShoppingCart;
  $: buyDisabled = !$canBuy;

  function observeFormValidityCallback(mutationList, observer) {
    for (const mutation of mutationList) {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "data-valid"
      ) {
        const validity = mutation.target.getAttribute("data-valid") === "true";
        requiredQuestionsAnswered.set(validity);
      }
    }
  }

  const observer = new MutationObserver(observeFormValidityCallback);

  onMount(() => {
    const formEl = document.querySelector(`form[id=${form}]`);
    
    if (!formEl) {
      requiredQuestionsAnswered.set(true);
      return;
    }
    
    const validity = formEl.getAttribute("data-valid") === "true";
    requiredQuestionsAnswered.set(validity);

    observer.observe(formEl, {
      attributes: true,
      childList: false,
      subtree: false,
    });

    return () => observer.disconnect();
  });

  function handleClick() {
    setTimeout(() => ($submitted = true), 100);
    return true;
  }
</script>

<style>
  .inline-block {
    display: inline-block;
  }
</style>

<div class={containerClass}>
  {#if allowShoppingCart}
    <div class={cellClass}>
      <button
        {form}
        on:click={handleClick}
        disabled={!$canAddToShoppingCart}
        class={cartClass}
        name="button"
        type="submit"
        id="add_tickets_to_cart_button"
        value="shopping_cart">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
        </svg>

        {strings.cart}
      </button>
    </div>
  {/if}
  <div class={cellClass}>
    <button
      {form}
      on:click={handleClick}
      disabled={!$canBuy}
      class={payClass}
      name="button"
      type="submit"
      data-disable-with-text="<span>Loading...</span>"
      id="buy_tickets_button"
      value="false">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 h-6">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
      </svg>

      {strings.pay}
    </button>
  </div>
</div>
